import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar } from './snackbarSlice';
import { t } from 'i18next';
import { getDropdownData } from '../../ApiServices/DropdownDataServices';

export const initialState = {
  value: {
    data: {
      PaymentMethod: [],
      SetupFee: [],
      DeliveryTimeframe: [],
      SubscriptionPack: [],
      PaymentTerms: []
    }
  },
  loading: false,
  error: null,
  selectedValue: null
};

const dropdownDataSlice = createSlice({
  name: 'dropdownData',
  initialState: initialState,
  reducers: {
    clearDropdownDataState(state: any) {
      state.value = initialState.value;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
    }
  },
  extraReducers: builder => {
    builder.addCase(fetchDropdownData.fulfilled, (state: any, action: any) => {
      state.error = initialState.error;
      state.loading = initialState.loading;
      state.selectedValue = initialState.selectedValue;
      state.value.data = action?.payload?.data;
    });
    builder.addCase(fetchDropdownData.rejected, (state: any, action: any) => {
      state.error = action?.payload?.error?.message;
      state.loading = false;
      state.selectedValue = initialState?.selectedValue;
    });
  }
});

export const dropdownDataState = (state: RootState) => state?.dropdownData;
export const { clearDropdownDataState } = dropdownDataSlice.actions;
export default dropdownDataSlice.reducer;

export const fetchDropdownData = createAsyncThunk(
  'dropdown/fetchDropdownData',
  async (_, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FETCHING_DATA') }));
      return fulfillWithValue(await getDropdownData());
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
